import React from 'react';

const MaritalStatusFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3548 12.6299L14.1663 12.8213L13.9779 12.6299C13.635 12.2795 13.1655 12.082 12.6752 12.082C12.185 12.082 11.7154 12.2795 11.3726 12.6299V12.6299C10.6531 13.365 10.6531 14.5403 11.3726 15.2753L13.1352 17.065C13.4066 17.3424 13.7783 17.4987 14.1663 17.4987C14.5544 17.4987 14.9261 17.3424 15.1975 17.065L16.9601 15.2754C17.6795 14.5403 17.6795 13.365 16.9601 12.6299V12.6299C16.6172 12.2795 16.1476 12.0821 15.6574 12.0821C15.1672 12.0821 14.6976 12.2795 14.3548 12.6299Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33333 12.5H5.83333C3.99238 12.5 2.5 13.9924 2.5 15.8333V16.6667"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="9.16634" cy="5.83333" r="3.33333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default MaritalStatusFilterIcon;
